/* eslint-disable camelcase */
import { buildParams } from '@/helpers/url';

const initialState = {
  idpData: {
    statuses: {
      all: {
        id: 'all',
        title: 'All status',
      },
      '2': {
        id: 2,
        icon: 'task-done',
        title: 'Completed',
        color: 'green',
        total: '0',
      },
      '1': {
        id: 1,
        icon: 'task-on-progress',
        title: 'In progress',
        color: 'orange',
        total: '0',
      },
      '0': {
        id: 0,
        icon: 'task-todo',
        title: 'To do',
        color: 'gray',
        total: '0',
      },
    },
  },
};

const getters = {
  idpData(state) {
    return state.idpData;
  },
};

const actions = {
  async getIdpList(context, params) {
    try {
      const queries = buildParams(params);
      const url = `${this._vm.$endPoint}/individual-development-plan?`;
      const { data, response } = await this._vm.$axios.get(url + queries);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch individual plan';
    } catch (err) {
      throw Error(err);
    }
  },
  async getIdpDetail(context, params) {
    try {
      const queries = buildParams(params.payload);
      const url = `${this._vm.$endPoint}/individual-development-plan/detail/${params.uuid}?`;
      const { data, response } = await this._vm.$axios.get(url + queries);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch individual plan detail';
    } catch (err) {
      throw Error(err);
    }
  },
  async detailActionPlan(context, uuid) {
    const path = `${this._vm.$endPoint}/action-plan/${uuid}`;

    try {
      const { data, response } = await this._vm.$axios.get(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data.data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch action plan detail';
    } catch (err) {
      throw Error(err);
    }
  },
  async updateActionPlanStatus(context, payload) {
    const path = `${this._vm.$endPoint}/action-plan/update-status/${payload.uuid}`;

    try {
      const { data, response } = await this._vm.$axios.post(path, { status: payload.status });

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return data.data;
      }

      throw response?.data?.message || data?.message || 'Failed to update action plan status';
    } catch (err) {
      throw Error(err);
    }
  },
  async createActionPlan(context, payload) {
    const path = `${this._vm.$endPoint}/action-plan/create`;

    try {
      const { data, response } = await this._vm.$axios.post(path, payload);

      if (data?.status === 200 || data?.status_code === 200) {
        return 'Action plan successfully added';
      }

      throw response?.data?.message || data?.message || 'Failed to add action plan';
    } catch (err) {
      throw Error(err);
    }
  },
  async editActionPlan(context, payload) {
    const path = `${this._vm.$endPoint}/action-plan/${payload.uuid}`;

    try {
      const { data, response } = await this._vm.$axios.put(path, payload.payload);

      if (data?.status === 200 || data?.status_code === 200) {
        return 'Action plan successfully edited';
      }

      throw response?.data?.message || data?.message || 'Failed to edit action plan';
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteActionPlan(context, uuid) {
    const path = `${this._vm.$endPoint}/action-plan/${uuid}`;

    try {
      const { data, response } = await this._vm.$axios.delete(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.data) {
        return 'Action plan successfully deleted';
      }

      throw response?.data?.message || data?.message || 'Failed to delete action plan';
    } catch (err) {
      throw Error(err);
    }
  },
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  getters,
  actions,
};
